module.exports = __webpack_public_path__ + "img/level-3.9c030f0a.svg";